<template>
    <div />
</template>

<script>
export default {
    types: [
        "ipAddress"
    ],
    mounted() {
        this.getUserIpAddress();
    },
    methods: {
        async getUserIpAddress() {
            // Fetching IP address from a public API
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            const ipAddress = data.ip;

            // Emitting the IP address through input event
            this.$emit('input', ipAddress);
        }
    }
};
</script>
